<p-toast></p-toast>
<app-spinner></app-spinner>

<ng-container *ngIf="dataTable.length > 0; else no_survey_found">
  <p-table
    #surveyTable
    [columns]="dataColumn"
    [value]="dataTable"
    dataKey="id"
    *ngIf="dataTable"
    styleClass="p-datatable-responsive-demo"
    [paginator]="true"
    [rows]="50"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[5, 10, 50]"
    [globalFilterFields]="['firstname', 'gender', 'email']"
  >
    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="surveyTable.filterGlobal($event.target.value, 'contains')"
            placeholder="Search.."
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pSortableColumn="name">
          <p-sortIcon field="name"></p-sortIcon>
          Name
        </th>
        <th>Gender</th>
        <th>Email</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <ng-container *ngIf="!isDefaultStudy">
        <tr [routerLink]="['user/', rowData.userId]" *ngIf="rowData.userId | getUserById | async as user">
          <td>{{ user.firstname }} {{ user.lastname }}</td>
          <td>{{ user.gender }}</td>
          <td>{{ user.email }}</td>
        </tr>
      </ng-container>
      <ng-container *ngIf="isDefaultStudy">
        <tr [routerLink]="['user/', rowData.uuid]">
          <td>{{ rowData.firstname }} {{ rowData.lastname }}</td>
          <td>{{ rowData.gender }}</td>
          <td>{{ rowData.email }}</td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</ng-container>
<ng-template #no_survey_found>
  <div class="noProductFound d-flex-col d-flex-centre">
    <span>No user data found with the given name.</span>
    <img src="assets/images/core/not-found.png" />
  </div>
</ng-template>
